import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomerProfileSetupService {

  constructor(private http:HttpClient) { }

  customerProfileSetupForm: FormGroup = new FormGroup(
    {
      id: new FormControl(null),
      name: new FormControl('', Validators.required),
      street: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zipcode: new FormControl('', Validators.required),
      contactName: new FormControl('', Validators.required),
      phone1: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
      phone2: new FormControl(''),
      gender: new FormControl('1', Validators.required),
      fax: new FormControl(''),
      email: new FormControl('', [Validators.required, Validators.email]),
    }
  )

  initializeGroup() {
    this.customerProfileSetupForm.setValue({
      id: null,
      name: '',
      street: '',
      city: '',
      state: '',
      zipcode: '',
      contactName: '',
      phone1: '',
      phone2: '',
      gender: '1',
      fax: '',
      email: '',
    })
  }

  onClear() {
    this.customerProfileSetupForm.reset();
    this.initializeGroup();
  }

}
